import React from "react";
import { useNavigate } from "react-router-dom";

function Box({ title, url, color }) {
  const navigate = useNavigate();
  return (
    <div className={`admin_dashboard_box ${color}`} onClick={() => navigate(url)}>
      <h3>{title}</h3>
    </div>
  );
}

export default Box;
